import React, { useMemo } from "react";
import { mapSign } from "@/helpers/getCompatibilityBetweenSigns";
import CompatibilityLinkList from "../CompatibilityLinkList";

const CompatibilityListBySign = ({ signs }) => {
  if (!signs || signs.length === 0) return null;

  const actualSign = mapSign[signs[0]];

  const listSigns = Object.entries(mapSign).map(([key, otherSign]) => ({
    img: `/img/westernastrology/${key}.svg`,
    textLink: `${actualSign} con ${otherSign}`,
    url: `/horoscopo/compatibilidad-signos-zodiaco/${signs[0]}-${key}`,
    label: `Compatibilidad de ${actualSign} con ${otherSign}`,
    alt: `Signo de ${otherSign}`,
  }));

  return (
    <CompatibilityLinkList
      items={listSigns}
      title={`Compatibilidad de ${actualSign}`}
    />
  );
};

export default CompatibilityListBySign;
